// extracted by mini-css-extract-plugin
export default {"createFigure":"Links_createFigure__jm+KO","hidden":"Links_hidden__cbwMh","projectsActive":"Links_projectsActive__5S+V+"};